module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/dots.83ee0256.svg";